import React, { createContext, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProductList from "./components/product.list";
import ProductManager from "./components/product.manager";
import AlertModal from "./components/modal";
export const AppContext = createContext({ });
function App() {
  const [modalInfo, setModalInfo] = useState({
    show: false,
    type: "success", // "success", "warning", or "error"
    title: "",
    message: "",
  });

  const showAlert = (type, title, message) => {
    setModalInfo({ show: true, type, title, message });
  };

  return (
   <AppContext.Provider value={{ showAlert }}>
     <Router>
      <Routes>
        <Route exact path="/" element={<ProductList />} />
        <Route path="/product/:id" element={<ProductManager />} />
      </Routes>
      {modalInfo.show && (
        <AlertModal
          type={modalInfo.type}
          title={modalInfo.title}
          message={modalInfo.message}
          onClose={() => setModalInfo((prev) => ({ ...prev, show: false }))}
        />
      )}
    </Router>
   </AppContext.Provider>
  );
}

export default App;
